// extracted by mini-css-extract-plugin
export default {"fruitviewexample":"fed57fd9bc306249b5e2","steps":"b9740b4fff05e2446b38"};